import { Controller } from "@hotwired/stimulus"

// Fullscreen media preview for a Pinterest-style gallery.
export default class extends Controller {
  static targets = ["overlay", "slide", "prevButton", "nextButton"]

  connect () {
    this.index = 0
    this.onKeydown = this.onKeydown.bind(this)
  }

  disconnect () {
    this.unlockBody()
    document.removeEventListener("keydown", this.onKeydown)
  }

  open (event) {
    const index = Number(event.params.index)
    if (Number.isNaN(index)) return

    this.showSlide(index)
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.setAttribute("aria-hidden", "false")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.onKeydown)
  }

  close () {
    this.pauseVideos()
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.setAttribute("aria-hidden", "true")
    this.unlockBody()
    document.removeEventListener("keydown", this.onKeydown)
  }

  closeBackground (event) {
    if (event.target === event.currentTarget) this.close()
  }

  next () {
    this.showSlide(this.index + 1)
  }

  prev () {
    this.showSlide(this.index - 1)
  }

  onKeydown (event) {
    if (this.overlayTarget.classList.contains("hidden")) return

    switch (event.key) {
      case "Escape":
        event.preventDefault()
        this.close()
        break
      case "ArrowRight":
        event.preventDefault()
        this.next()
        break
      case "ArrowLeft":
        event.preventDefault()
        this.prev()
        break
    }
  }

  showSlide (index) {
    if (!this.hasSlideTarget) return

    const total = this.slideTargets.length
    this.index = ((index % total) + total) % total
    this.pauseVideos()

    this.slideTargets.forEach((slide, i) => {
      const active = i === this.index
      slide.classList.toggle("hidden", !active)
      if (active) this.playIfVideo(slide)
    })

    const multi = total > 1
    this.prevButtonTargets.forEach((button) => button.classList.toggle("hidden", !multi))
    this.nextButtonTargets.forEach((button) => button.classList.toggle("hidden", !multi))
  }

  playIfVideo (slide) {
    const video = slide.querySelector("video")
    if (!video) return

    video.currentTime = 0
    video.play().catch(() => {})
  }

  pauseVideos () {
    this.slideTargets.forEach((slide) => {
      const video = slide.querySelector("video")
      if (video) {
        video.pause()
        video.currentTime = 0
      }
    })
  }

  unlockBody () {
    document.body.classList.remove("overflow-hidden")
  }
}
